import { render, staticRenderFns } from "./CustomerLimits.vue?vue&type=template&id=18003a5d&scoped=true&"
import script from "./CustomerLimits.vue?vue&type=script&lang=js&"
export * from "./CustomerLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18003a5d",
  null
  
)

export default component.exports